"use strict";
import { noop } from "lodash";
import { createContext } from "react";
export const OptionMenuItemsContext = createContext({
  registerMenuItem: noop,
  unregisterMenuItem: noop
});
